import React from "react"
import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types"
import Helmet from "react-helmet"

const SEO = ({ lang, meta, keywords }) => {
  const data = useStaticQuery(graphql`
  query SEOInfo {
    seo1: datoCmsSeo {
      seoMeta {
        description
        title
        image {
          url
        }
      }
    },
    seo2: datoCmsMetadataSite {
      title
      author
    },
    favicon: datoCmsCommon {
      favicon16x16 {
        url(imgixParams: {auto: "format", q: 90})
      }
      favicon32x32 {
        url(imgixParams: {auto: "format", q: 90})
      }
      favicon64x64 {
        url(imgixParams: {auto: "format", q: 90})
      }
    }
  }
`)

  const title = data.seo1.seoMeta.title;
  const metaDescription = data.seo1.seoMeta.description;

  const site = {
    siteMetadata: {
      title: data.seo2.title,
      author: data.seo2.author,
    },
  }

  const favicon16x16 = data.favicon.favicon16x16.url;
  const favicon32x32 = data.favicon.favicon32x32.url;
  const favicon64x64 = data.favicon.favicon64x64.url;

  const faviconLinks = [
    { rel: "icon", type: "image/png", sizes: "16x16", href: favicon16x16 },
    { rel: "icon", type: "image/png", sizes: "32x32", href: favicon32x32 },
    { rel: "shortcut icon", type: "image/png", href: favicon64x64 },
  ];

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      link={faviconLinks}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(
        keywords.length > 0
          ? {
            name: `keywords`,
            content: keywords.join(`, `),
          }
          : []
      )
        .concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
}

export default SEO
